import React, { Component, createRef } from "react";

class VideoControls extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.isPlaying !== nextProps.isPlaying;
  }

  render() {
    const { isPlaying, onPlay, onPause, onRestart, onJumpToTime } = this.props;

    return (
      <div className="video-controls-overlay">
        <button
          onClick={isPlaying ? onPause : onPlay}
          className="control-button"
        >
          {isPlaying ? "Pause" : "Play"}
        </button>
        <button onClick={onRestart} className="control-button">
          Restart
        </button>
        <button onClick={() => onJumpToTime(30)} className="control-button">
          Jump to 30s
        </button>
      </div>
    );
  }
}

class VideoDetails extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      this.props.currentVideo?.title !== nextProps.currentVideo?.title ||
      this.props.currentVideo?.description !==
        nextProps.currentVideo?.description ||
      this.props.currentVideo?.userViewed?.testPassed !==
        nextProps.currentVideo?.userViewed?.testPassed ||
      this.props.currentVideo?.userViewed?.completed !==
        nextProps.currentVideo?.userViewed?.completed
    );
  }

  render() {
    const { currentVideo, onQuizClick, t } = this.props;

    return (
      <div className="video-details">
        <div className="video-details-row">
          <div className="video-title">
            <b>{currentVideo?.title}</b>
          </div>
          <div className="quiz-section">
            {currentVideo?.userViewed?.testPassed ? (
              <div className="test-passed">
                {`${t("test_passed")} `}
                <i className="check-icon"></i>
              </div>
            ) : (
              <button
                onClick={onQuizClick}
                className="quiz-button"
                disabled={currentVideo?.userViewed?.completed !== 1}
              >
                {t("quiz")}
              </button>
            )}
          </div>
        </div>
        <p className="video-description">{currentVideo?.description}</p>
      </div>
    );
  }
}

class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      isLoading: true,
      error: null,
    };
    this.videoRef = createRef();
  }

  componentDidMount() {
    this.setInitialVideoTime();
    this.addVideoEventListeners();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentVideo?.videoUrl !== this.props.currentVideo?.videoUrl
    ) {
      this.setState({ isLoading: true, error: null });
      // this.setInitialVideoTime();
      this.removeVideoEventListeners();
      const video = this.videoRef.current;
      if (video) {
        video.currentTime = 0; // Reset time
        video.load(); // Force reload of new source
        this.setInitialVideoTime();
        this.addVideoEventListeners(); // Re-add listeners
      }
    }
  }

  componentWillUnmount() {
    this.removeVideoEventListeners();
  }

  setInitialVideoTime = () => {
    const { currentVideo } = this.props;
    const video = this.videoRef.current;

    if (video && currentVideo?.userViewed?.progress) {
      const startTime = Math.max(
        0,
        Number(currentVideo.userViewed.progress) - 1
      );
      video.currentTime = startTime;
    }
  };

  addVideoEventListeners = () => {
    const video = this.videoRef.current;
    if (video) {
      video.addEventListener("timeupdate", this.handleTimeUpdate);
      video.addEventListener("ended", this.handleVideoEnd);
      video.addEventListener("loadeddata", this.handleVideoLoaded);
      video.addEventListener("error", this.handleVideoError);
    }
  };

  removeVideoEventListeners = () => {
    const video = this.videoRef.current;
    if (video) {
      video.removeEventListener("timeupdate", this.handleTimeUpdate);
      video.removeEventListener("ended", this.handleVideoEnd);
      video.removeEventListener("loadeddata", this.handleVideoLoaded);
      video.removeEventListener("error", this.handleVideoError);
    }
  };
  handleVideoLoaded = () => {
    this.setState({ isLoading: false });
  };

  handleVideoError = (e) => {
    console.error("Video loading error:", e);
    this.setState({
      isLoading: false,
      error: "Failed to load video. Please try again or contact support.",
    });
  };

  handleTimeUpdate = () => {
    const video = this.videoRef.current;
    if (video) {
      this.props.setDuration(video.currentTime);
    }
  };

  handleVideoEnd = () => {
    const { currentVideo, onFinish } = this.props;
    if (currentVideo?.id && currentVideo?.userViewed?.id) {
      onFinish({
        videoId: currentVideo.id,
        historyId: currentVideo.userViewed.id,
      });
    }
  };

  handlePlay = () => {
    const video = this.videoRef.current;
    if (video) {
      // video.play();
      // this.setState({ isPlaying: true });
      video
        .play()
        .then(() => {
          this.setState({ isPlaying: true });
        })
        .catch((error) => {
          console.error("Error playing video:", error);
          // Handle autoplay restrictions
          if (error.name === "NotAllowedError") {
            alert("Autoplay is blocked. Please click play to start the video.");
          }
        });
    }
  };

  handlePause = () => {
    const video = this.videoRef.current;
    const { currentVideo, videoProgressHandler } = this.props;

    if (video) {
      video.pause();
      this.setState({ isPlaying: false });
      videoProgressHandler({
        videoId: currentVideo?.id,
        categoryId: currentVideo?.userViewed?.categoryId,
        historyId: currentVideo?.userViewed?.id,
      });
    }
  };

  handleRestart = () => {
    const video = this.videoRef.current;
    if (video) {
      video.currentTime = 0;
      video.play();
      this.setState({ isPlaying: true });
    }
  };

  handleJumpToTime = (seconds) => {
    const video = this.videoRef.current;
    if (video) {
      video.currentTime = seconds;
    }
  };

  handleQuiz = () => {
    const { setQuiz, setShow } = this.props;
    setQuiz(true);
    setShow(true);
  };

  getOptimizedVideoUrl = (url) => {
   
    if (!url) return "";
    // For Dropbox shared links
    if (url.includes("dropbox.com/s/")) {
      return url.replace("www.dropbox.com/s/", "dl.dropboxusercontent.com/s/");
    }
    if (url.includes("dropbox.com/scl/")) {
      // console.log("url=========", url);

      return url.replace(
        "www.dropbox.com/scl/",
        "dl.dropboxusercontent.com/scl/"
      );
    }

    // For Dropbox shared folder links
    if (url.includes("dropbox.com/sh/")) {
      return url.replace(
        "www.dropbox.com/sh/",
        "dl.dropboxusercontent.com/sh/"
      );
    }

    // For standard Dropbox URLs, add dl=1
    if (url.includes("dropbox.com") && !url.includes("dl=1")) {
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}dl=1`;
    }

    // For replay.dropbox.com URLs
    if (url.includes("replay.dropbox.com")) {
      return url;
    }

    return url;
  };

  render() {
    const { currentVideo, t } = this.props;
    const { isPlaying, isLoading, error } = this.state;

    if (!currentVideo?.videoUrl) return null;
    // console.log("currentVideo.videoUrl", currentVideo.videoUrl);

    const optimizedVideoUrl = this.getOptimizedVideoUrl(currentVideo.videoUrl);
    console.log({ optimizedVideoUrl });
    return (
      <div className="video-player">
        <div className="video-container">
          <a
            href="https://www.dropbox.com/scl/fi/qa2ch1xwm288lc6bfgnxf/shutterstock_v1761089.mov?rlkey=96fyb31vs2x95c9ke3is14k94&st=wcfro7ct&dl=0"
            class="dropbox-embed"
            data-height="300px"
            data-width="600px"
          ></a>
          {isLoading && <div className="video-loading">Loading video...</div>}
          {error && <div className="video-error">{error}</div>}
          <video
            ref={this.videoRef}
            className="video-element"
            // src={currentVideo.videoUrl}
            preload="metadata"
            controls={true}
            // crossOrigin="anonymous"
            controlsList="nodownload"
            playsInline
            key={optimizedVideoUrl}
          >
            {/* <source src={currentVideo.videoUrl} type="video/mp4" /> */}
            <source src={optimizedVideoUrl} type="video/mp4" />
            
            Your browser does not support the video tag.
          </video>


          {/* <VideoControls
            isPlaying={isPlaying}
            onPlay={this.handlePlay}
            onPause={this.handlePause}
            onRestart={this.handleRestart}
            onJumpToTime={this.handleJumpToTime}
          /> */}
        </div>

        <VideoDetails
          currentVideo={currentVideo}
          onQuizClick={this.handleQuiz}
          t={t}
        />
      </div>
    );
  }
}

export default VideoPlayer;

//24985496
